<div class="position-relative">
  @if (isLoading || isSaving) {
    <loader [config]="{ type: 'spinner', overlay: true, size: 'md', text: isSaving ? 'Saving...' : '' }"></loader>
  }

  <a href="javascript:void(0);" class="finance-back-link d-inline-block mb-3" (click)="cancel()">
    <i class="fa fa-solid fa-chevron-left me-1"></i>Back to Finance Analysis
  </a>

  <div class="finance-panel">
    <div class="finance-panel-header">
      <div>
        <h5 class="finance-panel-title">{{ isEditMode ? 'Edit Other Cost' : 'Add Other Cost' }}</h5>
        <small class="text-muted">
          Other Costs — free-form project expenses, optionally with a receipt attachment.
        </small>
      </div>
    </div>

    <div class="finance-panel-body">
      <form [formGroup]="form" class="row justify-content-center">
        <div class="col-xl-8 col-lg-10">
          <div class="row">
            <div class="col-md-6 mb-3">
              <select-field
                label="Category"
                [selectFormControl]="getControl('category')"
                [options]="categoryOptions">
              </select-field>
            </div>
            <div class="col-md-6">
              <input-field
                label="Amount"
                placeholder="0.00"
                suffix="€"
                [inputFormControl]="getControl('amount')"
                [type]="'number'"
                [readonly]="false">
              </input-field>
            </div>

            <div class="col-12">
              <input-field
                label="Description"
                placeholder="Detail of the expense"
                [inputFormControl]="getControl('description')"
                [type]="'text'"
                [readonly]="false">
              </input-field>
            </div>

            <div class="col-md-6">
              <input-field
                label="Date"
                [inputFormControl]="getControl('date')"
                [type]="'date'"
                [readonly]="false">
              </input-field>
            </div>

            <div class="col-12 mb-3">
              <projects-finance-attachment
                label="Attachment / Receipt"
                emptyText="No receipt attached (optional)"
                [attachment]="currentAttachment"
                [pendingFile]="selectedFile"
                [validateFile]="validateReceiptFile"
                (pendingFileChange)="onPendingFileChange($event)"
                (download)="openAttachment()">
              </projects-finance-attachment>
            </div>

            <div class="col-12">
              <textarea-field
                label="Notes"
                placeholder="Optional annotations"
                [textareaFormControl]="getControl('notes')"
                [readonly]="false"
                [height]="80">
              </textarea-field>
            </div>
          </div>
        </div>
      </form>

      <div class="finance-form-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-success" [disabled]="isSaving || isLoading" (click)="save()">Save row</button>
      </div>
    </div>
  </div>
</div>
